var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isMoreInfoIndex ? [_c('div', {
    class: ['mb-20', {
      'mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('components.sub.navigation.title'),
      "bordered": true,
      "back-button": {
        url: 'profile',
        hiddenAfterSizes: 'sm'
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    class: ['px-20 mb-20', {
      'px-md-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('station', {
    attrs: {
      "list": _vm.moreInfoMenu
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tw-invisible tw-hidden tw-text-white"
  }, [_c('p', [_vm._v(_vm._s(_vm.clientVersion))])])] : [_c('div', [_c('div', {
    class: ['mb-20', {
      'mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    class: ['display-none', {
      'display-lg-block': !_vm.deviceType.isMobile
    }]
  }, [_c('page-title', {
    attrs: {
      "titleTag": "h2",
      "title": _vm.$t('components.sub.navigation.title'),
      "bordered": true
    }
  })], 1), _vm._v(" "), _c('div', {
    class: ['display-block', {
      'display-lg-none': !_vm.deviceType.isMobile
    }]
  }, [!_vm.deviceType.isDesktop ? _c('page-title', {
    attrs: {
      "title": _vm.$t(_vm.mobileTitleAndRoute.key),
      "bordered": true,
      "back-button": {
        url: _vm.mobileTitleAndRoute.backRoute,
        hiddenAfterSizes: 'sm'
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: ['px-0 mb-20', {
      'px-lg-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [!_vm.isMoreInfoIndex ? [_c('div', {
    staticClass: "tw-px-5 md:tw-px-7.5 lg:tw-px-0"
  }, [_c('Breadcrumb', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbList
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    class: ['tw-grid tw-grid-cols-6 tw-gap-7.5', {
      'md:tw-grid-cols-12': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    class: ['tw-hidden', {
      'lg:tw-flex lg:tw-col-span-4': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "tw-w-full"
  }, [_c('left-menu', {
    attrs: {
      "title": _vm.$t('components.sub.navigation.title'),
      "list": _vm.moreInfoMenu
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: ['tw-col-span-6', {
      'md:tw-col-span-12 lg:tw-col-span-8 lg:tw-col-start-5 xl:tw-col-span-7 xl:tw-col-start-6': !_vm.deviceType.isMobile
    }]
  }, [_c('nuxt-child')], 1)])], 2)])])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }